<template lang="pug">
  v-container(class="px-4")
    v-row(class="mt-4")
      v-text-field(dense label="メールアドレス" required outlined type="email" name="user[email]" )
    v-row
      v-text-field(dense label="パスワード" required type="password" outlined name="user[password]")
    v-row(class="justify-end")
      v-btn(@click="dialog = false" color="primary" :elevation="0" block type="submit" name="commit") ログイン

    v-row(class="mt-10 justify-end")
      small *アカウントをお持ちでない方は、以下から会員登録ください
    v-row(class="mt-10 justify-end")
      v-btn(small text @click="registryUser()" color="primary" class="my-1") 『ひきこもり当事者・経験者』はこちら
    v-row(class="justify-end")
      v-btn(small text @click="registryGroup()" color="primary" class="my-1") 『居場所主催者』の方はこちら
    v-row(class="justify-end")
      v-btn(small text @click="registryVolunteer()" color="primary" class="my-1") 『ボランティア募集団体』の方はこちら
    v-row(class="justify-end")
      v-btn(small text @click="resetPassword()" color="primary" class="my-1") 『パスワードを忘れた』方はこちら
</template>

<script type="module">

export default {
  data: function () {
    return {
    }
  },
  methods: {
    open () {
      this.isOpen = true;
    },
    registryUser() {
      window.location = '/users/sign_up'
    },
    registryGroup() {
      window.location = '/groups/sign_up'
    },
    registryVolunteer() {
      window.location = '/volunteers/sign_up'
    },
    resetPassword() {
      window.location = '/users/password/new'
    },
  }
}
</script>
